export const ZoomMeetingEarlyAccessMinutes = 30;

export const EVENT_TITLE_HEIGHT = 72;
export const ZOOM_CONTROL_HEIGHT = 52;
